export const isSafari = (): boolean => /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
